/**
 * 文件中心接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocumentCenterService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 文件中心接口
  /**
   * 查询文件所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getDocumentInfoList(param) {
    const url = this.filefix + 'fileInfo/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看文件信息
   * @param param
   * @returns {Observable<any>}
   */
  getDocumentInfo(param) {
    const url = this.filefix + 'fileInfo/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新文件信息
   * @param param
   * @returns {Observable<any>}
   */
  updateDocumentInfo(param) {
    const url = this.filefix + 'fileInfo/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除文件单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteDocumentInfo(param) {
    const url = this.filefix + 'fileInfo/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加文件单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveDocumentInfo(param) {
    const url = this.filefix + 'fileInfo/save';
    return this.http.Post(url, param);
  }

  //#endregion

}
